import CrudBase from '../../CrudBase';
import axios from '../../../axios-common';

class RevenuesApi extends CrudBase {

  getRevenuesInfo = (representanteId, params) => axios.get(`${this.endpoint}/get-by?representativeId=${representanteId}`, params)

  defaultMethods = {
    ...this.defaultMethods,
    getRevenuesInfo: this.getRevenuesInfo,
  }
}

const revenues = new RevenuesApi('api/v1/revenues-info');

export default revenues.defaultMethods;

